import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MobileNav = () => {
  const [active, setActive] = useState("home"); // Active option state
  const [isVisible, setIsVisible] = useState(true); // Visibility state
  const [lastScrollY, setLastScrollY] = useState(0); // Track the last scroll position

  const accessToken = localStorage.getItem("@user");

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        // Scrolling down, hide navbar
        setIsVisible(false);
      } else {
        // Scrolling up, show navbar
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const navigate = useNavigate();
  const userPhoto = localStorage.getItem("@userPhoto");

  return (
    <div
      className={`fixed z-[50] bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-100 border-top-20 md:hidden transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex justify-around items-center py-3">
        {/* Home */}
        <button
          onClick={() => {
            navigate(`/`);
            setActive("home");
          }}
          className={`flex flex-col items-center ${
            active === "home" ? "text-black" : "text-gray-500"
          } hover:text-black`}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5192 7.82274C2 8.77128 2 9.91549 2 12.2039V13.725C2 17.6258 2 19.5763 3.17157 20.7881C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.7881C22 19.5763 22 17.6258 22 13.725V12.2039C22 9.91549 22 8.77128 21.4808 7.82274C20.9616 6.87421 20.0131 6.28551 18.116 5.10812L16.116 3.86687C14.1106 2.62229 13.1079 2 12 2C10.8921 2 9.88939 2.62229 7.88403 3.86687L5.88403 5.10813C3.98695 6.28551 3.0384 6.87421 2.5192 7.82274ZM9 17.25C8.58579 17.25 8.25 17.5858 8.25 18C8.25 18.4142 8.58579 18.75 9 18.75H15C15.4142 18.75 15.75 18.4142 15.75 18C15.75 17.5858 15.4142 17.25 15 17.25H9Z"
              fill="currentColor"
            />
          </svg>
        </button>
        {/* Search */}
        {
          localStorage.getItem("userType") !== "NO_HOST" &&
 <button
          onClick={() => {
            navigate(`/mobileSearch`);
            // setActive("search");
          }}
          className={`flex flex-col items-center ${
            active === "search" ? "text-black" : "text-gray-500"
          } hover:text-black`}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 6C13.7614 6 16 8.23858 16 11M16.6588 16.6549L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        }
       
        {accessToken && (
          <>
            {/* Notification */}

            <button
              onClick={() => {
                setActive(() => {
                  navigate(`/notification`);
                  return "notification";
                });
              }}
              className={`flex flex-col items-center ${
                active === "notification" ? "text-black" : "text-gray-500"
              } hover:text-black`}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="style=bulk">
                  <g id="notification-bell-new">
                    <path
                      id="vector (Stroke)"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.802 19.8312C15.4184 19.7694 15.8349 20.4237 15.5437 20.9534C15.3385 21.3267 15.0493 21.6524 14.7029 21.9193C14.3496 22.1913 13.9397 22.4001 13.5 22.5403C13.0601 22.6807 12.593 22.7517 12.1242 22.7517C11.6554 22.7517 11.1883 22.6807 10.7484 22.5403C10.3087 22.4001 9.89883 22.1913 9.54556 21.9193C9.1991 21.6524 8.90988 21.3267 8.70472 20.9534C8.41354 20.4237 8.83002 19.7694 9.44644 19.8312C9.63869 19.8505 11.1433 19.9976 12.1242 19.9976C13.1051 19.9976 14.6097 19.8505 14.802 19.8312Z"
                      fill="currentColor"
                    />
                    <path
                      id="Subtract"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.7423 1.98737C13.4465 0.967602 10.7932 1.00445 8.52901 2.08755C6.27704 3.16478 4.85335 5.3744 4.85335 7.79233L4.85335 9.06596C4.85335 10.1981 4.55987 11.3124 3.99943 12.3082L3.77239 12.7115C2.37502 15.1943 3.90274 18.2653 6.79044 18.7783C10.3154 19.4046 13.93 19.4046 17.455 18.7783L17.6156 18.7498C20.465 18.2435 22.0525 15.29 20.8335 12.7632L20.5681 12.213C20.1236 11.2918 19.8934 10.2885 19.8934 9.27297V8.9514C19.4108 9.23527 18.8484 9.39807 18.248 9.39807C16.4531 9.39807 14.998 7.943 14.998 6.14807C14.998 4.6268 16.0433 3.34965 17.4547 2.99558C17.003 2.63274 16.4979 2.323 15.9475 2.07851L15.7423 1.98737Z"
                      fill="currentColor"
                    />
                    <circle
                      id="vector"
                      cx="18.248"
                      cy="6.14844"
                      r="2.5"
                      fill="currentColor"
                    />
                  </g>
                </g>
              </svg>
            </button>
            {/* Bookmark */}
            <button
              onClick={() => {
                setActive(() => {
                  navigate(`/wishlist`);
                  return "bookmark";
                });
              }}
              className={`flex flex-col items-center ${
                active === "bookmark" ? "text-black" : "text-gray-500"
              } hover:text-black`}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21 11.0975V16.0909C21 19.1875 21 20.7358 20.2659 21.4123C19.9158 21.735 19.4739 21.9377 19.0031 21.9915C18.016 22.1045 16.8633 21.0849 14.5578 19.0458C13.5388 18.1445 13.0292 17.6938 12.4397 17.5751C12.1494 17.5166 11.8506 17.5166 11.5603 17.5751C10.9708 17.6938 10.4612 18.1445 9.44216 19.0458C7.13673 21.0849 5.98402 22.1045 4.99692 21.9915C4.52615 21.9377 4.08421 21.735 3.73411 21.4123C3 20.7358 3 19.1875 3 16.0909V11.0975C3 6.80891 3 4.6646 4.31802 3.3323C5.63604 2 7.75736 2 12 2C16.2426 2 18.364 2 19.682 3.3323C21 4.6646 21 6.80891 21 11.0975ZM8.25 6C8.25 5.58579 8.58579 5.25 9 5.25H15C15.4142 5.25 15.75 5.58579 15.75 6C15.75 6.41421 15.4142 6.75 15 6.75H9C8.58579 6.75 8.25 6.41421 8.25 6Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </>
        )}

        {/* Profile */}
        <button
          onClick={() => {
            setActive("profile");
            navigate(`/mobileProfile`);
          }}
          className={`items-center ${
            active === "profile" ? "text-black" : "text-gray-500"
          } hover:text-black`}
        >

{userPhoto ? (
          <div
            style={{
              backgroundImage: `url(${userPhoto})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "32px",
              height: "32px",
            }}
            className="user-image rounded-full"
            aria-label="Profile"
          />
        ) : (
          <div className="flex h-9 w-9 rounded-full border-2 border-[#e2b760] justify-center items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 52 52"
            fill="none"
          >
            <g clipPath="url(#clip0_6_19)">
              <path
                d="M1.70062e-05 25.9827C0.0162664 11.6325 11.665 -0.00406128 26.0051 1.0633e-06C40.3675 0.0040634 52.0447 11.7016 52 26.0416C51.9574 40.4061 40.3005 52.0305 25.9706 52C11.6143 51.9695 -0.0162324 40.3187 1.70062e-05 25.9827ZM26.0152 29.1595C24.3741 29.1595 22.7329 29.1453 21.0917 29.1615C16.4606 29.2062 12.8919 32.387 12.3272 36.9673C12.1525 38.3932 12.4673 39.6769 13.6048 40.6336C16.7105 43.2396 20.2813 44.765 24.3294 45.1082C28.932 45.4962 33.1487 44.3648 36.9409 41.7284C37.6823 41.2125 38.4135 40.6254 38.9883 39.9348C39.8678 38.8786 39.7906 37.5767 39.5591 36.3011C38.8015 32.1108 35.2632 29.1981 30.884 29.1615C29.2611 29.1473 27.6361 29.1595 26.0112 29.1595H26.0152ZM34.601 16.2981C34.4771 11.466 30.5894 7.67376 25.8853 7.7936C21.1039 7.91547 17.3137 11.7727 17.4011 16.4281C17.4925 21.2542 21.4187 25.0931 26.1392 24.9732C30.8819 24.8534 34.7188 20.9211 34.599 16.3001L34.601 16.2981Z"
                fill="#E2B760"
              />
            </g>
            <defs>
              <clipPath id="clip0_6_19">
                <rect width="52" height="52" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        )}
          
        </button>
      </div>
    </div>
  );
};

export default MobileNav;
